<template>
  <div class="approval-manage">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="flexBox">
      <text-title :mainTitle="mainTitle" :subheading="subheading" />
      <!--<div class="header-btn-box">-->
        <!--<a @click="modify" v-if="!modifyState">修改</a>-->
      <!--</div>-->
    </div>
    <form style="padding-top: 20px;">
      <div style="display: flex;justify-content: space-between;align-items: center;">
        <div style="border-left: 3px solid #00a0e6;padding: 0 5px;">启用配置</div>
        <div class="header-btn-box">
          <a @click="modify" v-if="!modifyState">修改</a>
          <a @click="cancel" v-if="modifyState">取消</a>
          <a @click="confirm" v-if="modifyState">确定</a>
        </div>
      </div>
      <div class="form-line">
        <div class="textBox" style="margin-right: 20px;">
          <!--<b class="red">*</b>-->
          <span class="line-text">是否启用：</span>
        </div>
        <el-switch
          v-model="isDisplayReleaseRoomOnPage"
          active-text="是"
          :disabled="!modifyState"
          inactive-text="否">
        </el-switch>
      </div>
      <div class="form-line">
        <div class="textBox" style="margin-right: 20px;">
          <!--<b class="red">*</b>-->
          <span class="line-text">是否开启审批：</span>
        </div>
        <el-switch
          v-model="configData.whetherToOpenApproval"
          active-text="是"
          :disabled="!modifyState"
          inactive-text="否">
        </el-switch>
      </div>

      <div style="display: flex;justify-content: space-between;align-items: center;">
        <div style="border-left: 3px solid #00a0e6;padding: 0 5px;">消息接收人配置</div>
        <div class="header-btn-box">
          <a @click="modifyPerson" v-if="!personModifyState">修改</a>
          <a @click="cancelPerson" v-if="personModifyState">取消</a>
          <a @click="confirmPerson" v-if="personModifyState">确定</a>
        </div>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">接收人：</span>
        </div>
        <el-select v-model="personCode" :disabled="!personModifyState" size="small" style="width: 280px" multiple>
          <el-option v-for="item in personList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div style="display: flex;justify-content: space-between;align-items: center;" v-if="isDisplayReleaseRoomOnPage">
        <div style="border-left: 3px solid #00a0e6;padding: 0 5px;">宣传标语配置</div>
        <div class="header-btn-box">
          <a @click="modifySlogan" v-if="!sloganModifyState">修改</a>
          <a @click="cancelSlogan" v-if="sloganModifyState">取消</a>
          <a @click="confirmSlogan" v-if="sloganModifyState">确定</a>
        </div>
      </div>
      <div class="form-line" v-if="isDisplayReleaseRoomOnPage">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">宣传标语：</span>
        </div>
        <el-input v-model="slogan" :disabled="!sloganModifyState" size="small" style="width: 280px" :maxlength="32" />
      </div>



      <!--<div class="form-btn-box" v-if="modifyState">-->
        <!--<button-confirm @confirm="confirm" />-->
        <!--<button-cancel @cancel="cancel" />-->
      <!--</div>-->

    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import InputSearch from '../../../components/Input/InputSearch'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/agent'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import TextTitle from '../../../components/Text/TextTitle'

  export default {
    components: {
      TextTitle,
      ButtonConfirm,
      ButtonCancel,
      TableMain,
      InputSearch,
      ButtonAdd,
      Breadcrumb},
    name: 'agent-config',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧经纪',
          name: 'investment-manage'
        }, {
          value: '配置管理'
        }],
        mainTitle: '配置管理',
        subheading: '',


        isDisplayReleaseRoomOnPage: false,
        configData: {},
        modifyState: false,

        personModifyState: false,
        personList: [],
        personCode: [],

        sloganModifyState: false,
        slogan: '',
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getResponsible()
      this.getConfig()
      this.getAgentMessageReceiver()
      this.getAgentPark()
    },
    methods: {
      // 查询配置
      getConfig () {
        this.$axios.get(`${api.getConfig}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (data) {
                this.configData = data
                if (data.isDisplayReleaseRoom  === '1') {
                  this.isDisplayReleaseRoomOnPage = true
                } else {
                  this.isDisplayReleaseRoomOnPage = false
                }
              }
            }
          })
          .catch(errorHandler('查询失败'))
      },

      // 点击修改
      modify () {
        this.modifyState = true
      },

      // 取消修改
      cancel () {
        this.modifyState = false
        this.getConfig()
      },

      // 修改
      confirm () {
        if (this.isDisplayReleaseRoomOnPage) {
          this.configData.isDisplayReleaseRoom = '1'
        } else {
          this.configData.isDisplayReleaseRoom = '0'
        }
        this.$axios.post(api.updateConfig, this.configData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.modifyState = false
              this.getConfig()
            }
          })
          .catch(errorHandler('修改失败'))
      },

      // 查询接收人
      getAgentMessageReceiver () {
        this.$axios.post(`${api.getAgentMessageReceiver}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (data) {
                this.personCode = []
                data.map(v => {
                  this.personCode.push(v.personCode)
                })
              }
            }
          })
          .catch(errorHandler('查询失败'))
      },

      // 获取接收人列表
      getResponsible () {
        this.$axios.post(api.getResponsiblePersonList, {})
          .then(res => {
            let list = res.data.data
            list.forEach(it => {
              it._value = it.code
              it._label = `${it.name} / ${it.phone}`
            })
            this.personList = list
          })
          .catch(errorHandler('获取接收人列表失败'))
      },

      // 点击修改
      modifyPerson () {
        this.personModifyState = true
      },

      // 取消修改
      cancelPerson () {
        this.personModifyState = false
        this.getAgentMessageReceiver()
      },

      // 修改
      confirmPerson () {
        let personArr = []
        this.personList.map(person => {
          this.personCode.map(v => {
            if (v === person.code) {
              let personObj = {
                personCode: person.code,
                personName: person.name
              }
              personArr.push(personObj)
            }
          })
        })
        this.$axios.post(api.modifyAgentMessageReceiver, personArr)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.personModifyState = false
              this.getAgentMessageReceiver()
            }
          })
          .catch(errorHandler('修改失败'))
      },


      // 查询宣传语
      getAgentPark () {
        this.$axios.get(`${api.getAgentPark}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (data) {
                if (data.agentPark) {
                  this.slogan = data.agentPark.slogan
                }
              }
            }
          })
          .catch(errorHandler('查询失败'))
      },

      // 点击修改
      modifySlogan () {
        this.sloganModifyState = true
      },

      // 取消修改
      cancelSlogan () {
        this.sloganModifyState = false
        this.getAgentPark()
      },

      // 修改
      confirmSlogan () {
        this.$axios.post(api.updateAgentPark, {
          yqAppCode: bus.global.yqCode,
          slogan: this.slogan
        })
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.sloganModifyState = false
              this.getAgentPark()
            }
          })
          .catch(errorHandler('修改失败'))
      },
    },
    watch: {}
  }
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 300px;
    /*padding: 0 124px;*/
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>
<style lang="less">
  .approval-manage {
    .approvalBox {
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Agent/agentConfig/agentConfig.vue